import {usePermissions as useBasePermissions} from 'react-admin';
import find from 'lodash/find';

export const ACCESS_DASHBOARD_ANALYTICS = 'access:dashboard:analytics';

export const ACCESS_LOCATION = 'access:location';
export const READ_LOCATION = 'read:location';
export const LIST_LOCATION = 'list:location';
export const EDIT_LOCATION = 'edit:location';
export const EDIT_LOCATION_SETTINGS = 'edit:location-settings';
export const EDIT_LOCATION_SCHEDULER = 'edit:location-scheduler';
export const EDIT_LOCATION_RESTING_STATE = 'edit:location-resting-state';
export const EDIT_LOCATION_STATIC_LOCATIONS = 'edit:location-static-locations';
export const DELETE_LOCATION = 'delete:location';
export const CREATE_LOCATION = 'create:location';

export const ACCESS_DATABASE = 'access:database';
export const READ_DATABASE = 'read:database';
export const LIST_DATABASE = 'list:database';
export const EDIT_DATABASE = 'edit:database'
export const EDIT_DATABASE_SETTINGS = 'edit:database-settings';
export const EDIT_DATABASE_MEDIA = 'edit:database-media';
export const DELETE_DATABASE = 'delete:database';
export const CREATE_DATABASE = 'create:database';

export const ACCESS_DATASOURCE = 'access:datasource';
export const READ_DATASOURCE = 'read:datasource';
export const LIST_DATASOURCE = 'list:datasource';
export const EDIT_DATASOURCE = 'edit:datasource'
export const DELETE_DATASOURCE = 'delete:datasource';
export const CREATE_DATASOURCE = 'create:datasource';

export const ACCESS_TAG = 'access:tag';
export const READ_TAG = 'read:tag';
export const LIST_TAG = 'list:tag';
export const EDIT_TAG = 'edit:tag';
export const DELETE_TAG = 'delete:tag';
export const CREATE_TAG = 'create:tag';

export const ACCESS_POST = 'access:post';
export const READ_POST = 'read:post';
export const LIST_POST = 'list:post';
export const EDIT_POST = 'edit:post';
export const EDIT_POST_SETTINGS = 'edit:post-settings';
export const EDIT_POST_TILES = 'edit:post-tiles';
export const EDIT_POST_FLYOUTS = 'edit:post-flyouts';
export const DELETE_POST = 'delete:post';
export const CREATE_POST = 'create:post';

export const ACCESS_MEDIA = 'access:media';
export const READ_MEDIA = 'read:media';
export const LIST_MEDIA = 'list:media';
export const EDIT_MEDIA = 'edit:media';
export const DELETE_MEDIA = 'delete:media';
export const CREATE_MEDIA = 'create:media';

export const ACCESS_CONTENT = 'access:content';
export const READ_CONTENT = 'read:content';
export const LIST_CONTENT = 'list:content';
export const EDIT_CONTENT = 'edit:content';
export const DELETE_CONTENT = 'delete:content';
export const CREATE_CONTENT = 'create:content';

export const ACCESS_LAYOUT = 'access:layout';
export const READ_LAYOUT = 'read:layout';
export const LIST_LAYOUT = 'list:layout';
export const EDIT_LAYOUT = 'edit:layout';
export const DELETE_LAYOUT = 'delete:layout';
export const CREATE_LAYOUT = 'create:layout';

export const ACCESS_SERVICES = 'access:services';
export const READ_SERVICES = 'read:services';
export const LIST_SERVICES = 'list:services';
export const EDIT_SERVICES = 'edit:services';
export const DELETE_SERVICES = 'delete:services';
export const CREATE_SERVICES = 'create:services';

export const ACCESS_SETTINGS = 'access:settings';
export const READ_SETTINGS = 'read:settings';
export const LIST_SETTINGS = 'list:settings';
export const EDIT_SETTINGS = 'edit:settings';
export const DELETE_SETTINGS = 'delete:settings';
export const CREATE_SETTINGS = 'create:settings';

export const ACCESS_RULE = 'access:rule';
export const READ_RULE = 'read:rule';
export const LIST_RULE = 'list:rule';
export const EDIT_RULE = 'edit:rule';
export const DELETE_RULE = 'delete:rule';
export const CREATE_RULE = 'create:rule';


export const ACTION_ACCESS = 'access';
export const ACTION_READ = 'read';
export const ACTION_VIEW = 'read';
export const ACTION_LIST = 'list';
export const ACTION_EDIT = 'edit';
export const ACTION_CREATE = 'create';
export const ACTION_DELETE = 'delete';

export const DATA_SOURCE_ACCESS = 'access:datasource';
export const DATA_SOURCE_READ =   'read:datasource';
export const DATA_SOURCE_VIEW =   'read:datasource';
export const DATA_SOURCE_LIST =   'list:datasource';
export const DATA_SOURCE_EDIT =   'edit:datasource';
export const DATA_SOURCE_CREATE = 'create:datasource';
export const DATA_SOURCE_DELETE = 'delete:datasource';


export const ACCESS_OPERATION = 'access:operation';
export const READ_OPERATION = 'read:operation';
export const LIST_OPERATION = 'list:operation';
export const EDIT_OPERATION = 'edit:operation'
export const DELETE_OPERATION = 'delete:operation';
export const CREATE_OPERATION = 'create:operation';


export const ACCESS_MANAGEMENT_SERVICES = 'access:management-services';
export const READ_MANAGEMENT_SERVICES =   'read:management-services';
export const LIST_MANAGEMENT_SERVICES =   'list:management-services';
export const EDIT_MANAGEMENT_SERVICES =   'edit:management-services';
export const DELETE_MANAGEMENT_SERVICES = 'delete:management-services';
export const CREATE_MANAGEMENT_SERVICES = 'create:management-services';


export const ACCESS_MANAGEMENT_USERS = 'access:management-users';
  export const READ_MANAGEMENT_USERS =   'read:management-users';
  export const LIST_MANAGEMENT_USERS =   'list:management-users';
  export const EDIT_MANAGEMENT_USERS =   'edit:management-users';
export const DELETE_MANAGEMENT_USERS = 'delete:management-users';
export const CREATE_MANAGEMENT_USERS = 'create:management-users';

const resourceToPermissionMapping = {
  setting: 'settings',
  service: 'services',
};

export const useResourceActionPermission = (resource, action) => {
  const normalizedInputResource = resource && String(resource).toLowerCase() || resource;

  const normalizedAction = String(action).toLowerCase();
  const normalizedResource = String(resourceToPermissionMapping[normalizedInputResource] || normalizedInputResource);

  return usePermissions(`${ normalizedAction }:${ normalizedResource }`)
};

export const usePermissions = (permission) => {
  const { loading, loaded, permissions } = useBasePermissions();
  
  const hasPermission = !!find(permissions, row => (row?.toLowerCase() === permission?.toLowerCase()));

  return { loading, loaded, hasPermission };
}

export default usePermissions;